import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const ReportFilterListDetails = () => {
  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Filter Type', value: 'filter_type' },
    { label: 'Criteria', value: 'criteria' }, // Added Criteria
    { label: 'Report', value: 'report' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];

  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/reporting/filter/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['reportFilter']} />;
};

export default ReportFilterListDetails;